<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>卡数量系数配置</span>
        </div>
        <el-table
          :data="formData"
          border
          style="width: 80%"
        >
          <el-table-column
            prop="numMin"
            label="数量"
          >
            <template v-slot:default="scope">
              <el-input v-model="scope.row.numMin" style="width: 35%" placeholder="最小数量" />
              -
              <el-input v-model="scope.row.numMax" style="width: 35%" placeholder="最大数量" />
            </template>
          </el-table-column>
          <el-table-column
            prop="coefficient"
            label="系数"
          >
            <template v-slot:default="scope">
              <el-input v-model="scope.row.coefficient" placeholder="系数" />
            </template>
          </el-table-column>
        </el-table>
        <el-button v-permisaction="['config:upLimit:add']" size="mini" style="margin-top: 10px;" type="primary" @click="add()">+</el-button>
        <el-button v-permisaction="['config:upLimit:add']" size="mini" style="margin-top: 10px;" type="primary" @click="onSubmit()">保存</el-button>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'
export default {
  name: 'CardNumCoefficientConfig',
  data() {
    return {
      formData: [
        {
          'numMin': 0,
          'numMax': 0,
          'coefficient': 0
        }
      ]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit() {
      for (const i in this.formData) {
        const tempDae = this.formData[i]
        if (tempDae.numMin === 0 && tempDae.numMax === 0) {
          this.msgError('最小数量，最大数量不能同时为0')
          return
        }
        if (tempDae.numMin > tempDae.numMax) {
          this.msgError('最小数量不能大于最大数量')
          return
        }
        this.formData[i].coefficient = parseFloat(tempDae.coefficient)
      }
      const data = JSON.stringify(this.formData)
      if (data.length < 1) {
        this.msgError('没有需要提交的数据')
        return
      }
      updateCommonCfg({ name: 'CARD_NUM_COEFFICIENT', data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getCommonCfg({ name: 'CARD_NUM_COEFFICIENT' }).then(res => {
        if (res.code === 200) {
          this.formData = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.formData.push({
        'numMin': 0,
        'numMax': 0,
        'coefficient': 0
      })
    },
    del(index) {
      this.formData = this.formData.filter((item, key) => {
        return key !== index
      })
    }
  }
}
</script>

<style scoped>
</style>
